import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import Bg from "../../images/bg/page_bg01.jpg";
import CtaSection from "../../components/CtaSection/CtaSection";
import { color } from "framer-motion";

const ComplaintPage = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };
  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <Header />
        <section
          className="page-title cp-page-title pt-120 pos-rel bg_img"
          style={{ backgroundImage: `url(${Bg})` }}
        >
          <div className="container">
            <div className="page-title-wrap pt-3 pb-5">
              <div className="row mt-none-30 align-items-center ">
                <div className="col-lg-12 text-center">
                  <div className="page-title-box">
                    <h2 className="title">File a Complaint</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="terms&conditions-section cp-det-bg">
          <div className="container">
            <div className="terms-section_inner pt-80 pb-75">
              <div className="row">
                <div className="col-lg-11 ">
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      Our complaints policy
                    </h2>
                    <p>
                      We are committed to delivering high quality money transfer
                      services to all our customers. We believe that listening
                      to your concerns and feedback is essential for improving
                      our standards and services. When something goes wrong, we
                      want to know about it and we will do our best to put it
                      right.
                    </p>
                    <p>
                      {" "}
                      We have a clear and transparent complaints handling
                      procedure in place, ensuring that your concerns are
                      addressed efficiently and fairly. If you have a complaint,
                      please contact us with the details.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">Complaint to:</h2>
                    <ul className="privacy-details">
                      <li>
                        {" "}
                        By email:{" "}
                        <a href="mailto:hello@tigrispay.com" style={{ color: "#2f3338" }}>
                          hello@tigrispay.com
                        </a>
                      </li>
                      <li>
                        {" "}
                        By Phone: <a href="tel:02030055883" style={{ color: "#2f3338" }}>+44 02030055883</a>
                      </li>
                      <li>
                        {" "}
                        By Post: 25 Cabot Square, Canary Wharf, London, E14 4QZ
                      </li>
                    </ul>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      What will happen next?
                    </h2>
                    <ul className="privacy-details">
                      <li>
                        We will send you a letter/email acknowledging receipt of
                        your complaint on the same day of receiving it,
                        enclosing a copy of this procedure. If you have
                        complained in person or on call, we will try to resolve
                        and reach the solution the same day.
                      </li>
                      <li>
                        If we are unable to resolve your complaint on the same
                        day, then we will further investigate your complaint.
                        This will normally involve finding details of your
                        complaint, reviewing your matter by speaking to the
                        member of staff who acted for you.
                      </li>
                      <li>
                        We will respond to you within 15 days or in 35 days in
                        exceptional circumstances with our Final Response which
                        may be a redress offer or remedial action.
                      </li>
                      <li>
                        If you are still not satisfied, you can then contact the
                        Financial Ombudsman Service, about your complaint.
                        Normally, you will need to bring a complaint to the
                        Financial Ombudsman Service within six months of
                        receiving a final written response from us about your
                        complaint.
                      </li>

                      <br />
                      <p>
                        For further information, you should contact the
                        Financial Ombudsman Service on:
                      </p>
                      <ul className="privacy-details">
                        <li>
                          Online:{" "}
                          <a
                            href="https://www.financial-ombudsman.org.uk/"
                            target="_blank"
                            style={{ color: "#2f3338" }}
                          >
                            https://www.financial-ombudsman.org.uk/
                          </a>
                        </li>
                        <li>
                          Email:{" "}
                          <a href="mailto:complaint.info@financial-ombudsman.org.uk" style={{ color: "#2f3338" }}>
                            complaint.info@financial-ombudsman.org.uk
                          </a>
                        </li>
                        <li>
                          By post: The Financial Ombudsman Service Exchange
                          Tower, London, E14 9SR
                        </li>
                        <li>
                         Phone: <a href="tel:08000234567" style={{ color: "#2f3338" }}>0800 023 4 567</a>{" "}
                          (free), <a href="tel:03001239123" style={{ color: "#2f3338" }}>0300 123 9 123 </a>
                          [weekdays from 8:00am - 5:00pm (GMT), and on Saturday
                          from 9:00am - 1:00pm (GMT)]
                        </li>
                      </ul>
                      <br />
                      <li>
                        If you're not in the UK, call{" "}
                        <a href="tel:442079640500" style={{ color: "#2f3338" }}>+44 20 7964 0500 </a>
                      </li>
                      <p>
                        FOS will not charge you for making a complaint and if
                        you are not satisfied with the outcome you can still
                        bring legal proceedings.
                      </p>
                    </ul>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
        </section>
        <CtaSection cClassNamclassName={"bg"} />
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default ComplaintPage;
